import React, { useState, useEffect } from "react";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Button, TextField, IconButton, Typography, CircularProgress,
    Snackbar, Menu, MenuItem,
    FormControl, InputLabel, Select, Box, Checkbox, TablePagination
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import BadgeIcon from '@mui/icons-material/Badge';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from "@mui/icons-material/Payment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_MEMBERS } from "../graphql/queries";
import EditUserDialog from "./Edituserdialog";
import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import PaymentConfirmationDialog from "./PaymentConfirmationDialog";
import GroupsIcon from '@mui/icons-material/Groups';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import NotLoggedIn from "../components/LoginExceptions";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const DataTable = () => {
    const { loading, error, data, refetch } = useQuery(GET_MEMBERS);
    const [filters, setFilters] = useState({
        First_Name: "",
        Mobile_Number: "",
        id: "",
        Payment_Status: "",
        ID_Card: "",
        Role: "",
    });
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedUserForDelete, setSelectedUserForDelete] = useState(null);
    const [selectedUserForPayment, setSelectedUserForPayment] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuUser, setMenuUser] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogMode, setDialogMode] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [fullNameInput, setFullNameInput] = useState('');
    const [showPanUpdateDialog, setShowPanUpdateDialog] = useState(false);


    const navigate = useNavigate();
    const storedUserType = localStorage.getItem("user_type");

    useEffect(() => {
        setPage(0);
    }, [filters, fullNameInput]); // 👈 include fullNameInput too



    if (!storedUserType) {
        return <NotLoggedIn />;
    }


    const handleRefresh = () => {
        setFilters({
            First_Name: "",
            Last_Name: "",
            Mobile_Number: "",
            id: "",
            Payment_Status: "",
            ID_Card: "",
            Role: "",
        });
        setFullNameInput('');
        refetch();
    };

    const handleCreate = () => {
        navigate("/userprofile");
    };

    const handleEdit = (user) => {
        handleMenuClose();
        setSelectedUser(user);
        setOpenEditModal(true);
    };

    const handlePayment = (user) => {
        handleMenuClose();
        setSelectedUserForPayment(user);
        setDialogMode("pay");
        setOpenDialog(true);
    };

    const handleDelete = (user) => {
        handleMenuClose();
        setSelectedUserForDelete(user);
        setDialogMode("delete");
        setOpenDialog(true);
    };
    const handleDownloadID = (user) => {
        console.log("Passed user to membership page:", user);
        navigate('/membership', { state: { user } });
        handleMenuClose();
    };

    const handleDownloadReceipt = (user) => {
        navigate(`/receipt`, { state: { user } });
    };

    const handleMenuOpen = (event, user) => {
        setMenuAnchorEl(event.currentTarget);
        setMenuUser(user);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuUser(null);
    };

    const handleCloseSnackbar = () => setSnackbarOpen(false);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (id) => selectedUsers.includes(id);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const allIds = filteredData.map((user) => user.id);
            setSelectedUsers(allIds);
        } else {
            setSelectedUsers([]);
        }
    };

    const handleCheckboxClick = (event, id) => {
        event.stopPropagation();
        setSelectedUsers((prev) =>
            prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
        );
    };

    const filteredData = (data?.members || data || []).filter((row) => {
        // Prepare full name and search input for filtering by full name
        const fullName = `${row.First_Name || ""} ${row.Last_Name || ""}`.toLowerCase().trim();
        const searchInput = fullNameInput.toLowerCase().trim();

        // Check if fullName includes the searchInput
        const matchesFullName = fullName.includes(searchInput);

        // Check all filters in the filters object
        const matchesFilters = Object.keys(filters).every((key) => {
            if (!filters[key]) return true; // Skip if filter value empty

            const filterValue = filters[key].toLowerCase();

            if (key === "Payment_Status") {
                return row.Payment_Status?.toLowerCase() === filterValue;
            }

            if (key === "ID_Card") {
                return row.ID_Card?.toString().toLowerCase() === filterValue;
            }

            if (key === "Role") {
                return row.Role?.toString().toLowerCase() === filterValue;
            }

            // Default: check if row[key] includes filterValue
            const rowValue = row[key]?.toString().toLowerCase();
            if (!rowValue) return false;
            return rowValue.includes(filterValue);
        });

        // Return true only if both fullName matches AND filters match
        return matchesFullName && matchesFilters;
    });

    const StatCard = ({ title, count, icon, iconColor }) => (
        <Card
            sx={{
                minWidth: 160,
                backgroundColor: "#fff",
                borderRadius: 2,
                border: "2px solid #57511F",
                boxShadow: "none",
            }}
        >
            <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: '16px !important' }}>
                <Box>
                    <Typography variant="body2" color="text.secondary">
                        {title}
                    </Typography>
                    <Typography variant="h6" fontWeight="bold">
                        {count}
                    </Typography>
                </Box>
                <Box sx={{ color: iconColor }}>
                    {icon}
                </Box>
            </CardContent>
        </Card>
    );

    return (
        <div style={{ padding: 20 }}>
            {/* Title and Actions */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                <Typography variant="h4" sx={{ fontWeight: "bold", color: "#2A289C" }}>
                    Manage Users
                </Typography>
                <div style={{ display: "flex", gap: 10 }}>
                    <Button variant="contained" color="success" onClick={handleCreate} sx={{ borderRadius: "20px" }} >
                        Create
                    </Button>
                    <IconButton color="primary" onClick={handleRefresh}>
                        <RefreshIcon />
                    </IconButton>
                </div>
            </div>

            {/* Stat Cards */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" }, // Column on mobile, row on tablet and up
                    gap: 2,
                    mb: 2,
                    flexWrap: "wrap", // Allow wrap on smaller screens
                }}
            >
                <StatCard
                    title="Total"
                    count={filteredData.filter(user => ["Paid", "Unpaid", "Failed"].includes(user.Payment_Status)).length}
                    icon={<GroupsIcon sx={{ fontSize: 50 }} />}
                    iconColor="blue"
                />
                <StatCard
                    title="Paid"
                    count={filteredData.filter(user => user.Payment_Status === "Paid").length}
                    icon={<AttachMoneyIcon sx={{ fontSize: 50 }} />}
                    iconColor="green"
                />
                <StatCard
                    title="Unpaid"
                    count={filteredData.filter(user => ["Unpaid"].includes(user.Payment_Status)).length}
                    icon={<MoneyOffIcon sx={{ fontSize: 50 }} />}
                    iconColor="red"
                />
                <StatCard
                    title="Failed"
                    count={filteredData.filter(user => ["Failed"].includes(user.Payment_Status)).length}
                    icon={<MoneyOffIcon sx={{ fontSize: 50 }} />}
                    iconColor="orange"
                />
            </Box>

            {/* Filter Fields */}
            <div
                style={{
                    display: "flex",
                    gap: 10,
                    flexWrap: "wrap",
                    marginBottom: 10,
                }}
            >
                <TextField
                    label="Name"
                    size="small"
                    variant="outlined"
                    value={fullNameInput}
                    onChange={(e) => setFullNameInput(e.target.value)}
                    sx={{ flex: '1 1 230px', minWidth: 230 }}
                />

                <TextField
                    label="Mobile Number"
                    size="small"
                    variant="outlined"
                    value={filters.Mobile_Number}
                    onChange={(e) => setFilters({ ...filters, Mobile_Number: e.target.value })}
                    sx={{ flex: '1 1 230px', minWidth: 230 }}
                />

                <TextField
                    label="Member ID"
                    size="small"
                    variant="outlined"
                    value={filters.id}
                    onChange={(e) => setFilters({ ...filters, id: e.target.value })}
                    sx={{ flex: '1 1 230px', minWidth: 230 }}
                />

                <FormControl size="small" sx={{ flex: '1 1 230px', minWidth: 230 }}>
                    <InputLabel>Payment Status</InputLabel>
                    <Select
                        value={filters.Payment_Status}
                        onChange={(e) => setFilters({ ...filters, Payment_Status: e.target.value })}
                        label="Payment Status"
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Paid">Paid</MenuItem>
                        <MenuItem value="Unpaid">Unpaid</MenuItem>
                        <MenuItem value="Failed">Failed</MenuItem>
                    </Select>
                </FormControl>

                <FormControl size="small" sx={{ flex: '1 1 230px', minWidth: 230 }}>
                    <InputLabel>ID Card Status</InputLabel>
                    <Select
                        value={filters.ID_Card}
                        onChange={(e) => setFilters({ ...filters, ID_Card: e.target.value })}
                        label="ID Card Status"
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Generated">Generated</MenuItem>
                        <MenuItem value="Not Generated">Not Generated</MenuItem>
                    </Select>
                </FormControl>

                <FormControl size="small" sx={{ flex: '1 1 230px', minWidth: 230 }}>
                    <InputLabel>User Type</InputLabel>
                    <Select
                        value={filters.Role}
                        onChange={(e) => setFilters({ ...filters, Role: e.target.value })}
                        label="User Type"
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="SuperUser">SuperUser</MenuItem>
                        <MenuItem value="Admin">Admin</MenuItem>
                        <MenuItem value="User">User</MenuItem>
                    </Select>
                </FormControl>
            </div>


            {/* Main Table */}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ backgroundColor: "#FAD707" }}>
                        <TableRow>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    sx={{
                                        color: "#57511F",
                                        '&.Mui-checked': { color: "#57511F" },
                                    }}
                                    indeterminate={selectedUsers.length > 0 && selectedUsers.length < filteredData.length}
                                    checked={filteredData.length > 0 && selectedUsers.length === filteredData.length}
                                    onChange={handleSelectAllClick}
                                />
                            </TableCell>
                            <TableCell><b>Name</b></TableCell>
                            <TableCell><b>Mobile Number</b></TableCell>
                            <TableCell><b>Member ID</b></TableCell>
                            <TableCell><b>Payment</b></TableCell>
                            <TableCell><b>ID Card</b></TableCell>
                            <TableCell><b>User Type</b></TableCell>
                            <TableCell><b>Actions</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <TableRow><TableCell colSpan={8} align="center"><CircularProgress /></TableCell></TableRow>
                        ) : error ? (
                            <TableRow><TableCell colSpan={8} align="center"><Typography color="error">Error loading users</Typography></TableCell></TableRow>
                        ) : filteredData.length > 0 ? (
                            filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                <TableRow key={index} hover selected={isSelected(row.id)}
                                    sx={{ backgroundColor: index % 2 === 0 ? "#F8F9E9" : "#ffffff" }}>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={isSelected(row.id)}
                                            onChange={(e) => handleCheckboxClick(e, row.id)}
                                            sx={{ color: "#57511F", '&.Mui-checked': { color: "#57511F" } }}
                                        />
                                    </TableCell>
                                    <TableCell>{row.First_Name || row.Last_Name ? `${row.First_Name || ""} ${row.Last_Name || ""}`.trim() : "N/A"}</TableCell>
                                    <TableCell>{row.Mobile_Number || "N/A"}</TableCell>
                                    <TableCell>{row.id || "N/A"}</TableCell>
                                    <TableCell>{row.Payment_Status || "Unpaid"}</TableCell>
                                    <TableCell>
                                        {row.ID_Card || "Not Generated"}
                                    </TableCell>
                                    <TableCell>{row.Role || "N/A"}</TableCell>
                                    <TableCell>
                                        <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                        <Menu
                                            anchorEl={menuAnchorEl}
                                            open={Boolean(menuAnchorEl)}
                                            onClose={handleMenuClose}
                                            PaperProps={{ sx: { boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', borderRadius: 1.5 } }}
                                        >
                                            <MenuItem onClick={() => handleEdit(menuUser)}>
                                                <EditIcon sx={{ color: "blue", mr: 1 }} /> Edit
                                            </MenuItem>

                                            {menuUser?.Payment_Status !== "Paid" && (
                                                <MenuItem onClick={() => handlePayment(menuUser)}>
                                                    <PaymentIcon sx={{ color: "green", mr: 1 }} /> Pay
                                                </MenuItem>
                                            )}

                                            {(storedUserType === "superuser" || storedUserType === "admin") && (
                                                <>
                                                    {menuUser?.Payment_Status === "Paid" && (
                                                        <MenuItem onClick={() => handleDownloadReceipt(menuUser)}>
                                                            <ReceiptIcon sx={{ color: "orange", mr: 1 }} /> Receipt
                                                        </MenuItem>
                                                    )}

                                                    {menuUser?.Payment_Status === "Paid" && (
                                                        <>
                                                            {menuUser?.ID_Card === "Generated" ? (
                                                                <MenuItem onClick={() => handleDownloadID(menuUser)}>
                                                                    <BadgeIcon sx={{ color: "purple", mr: 1 }} /> ID
                                                                </MenuItem>
                                                            ) : (
                                                                <MenuItem onClick={() => setShowPanUpdateDialog(true)}>
                                                                    <BadgeIcon sx={{ color: "gray", mr: 1 }} /> ID
                                                                </MenuItem>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}

                                            {storedUserType === "superuser" && (
                                                <MenuItem onClick={() => handleDelete(menuUser)}>
                                                    <DeleteIcon sx={{ color: "red", mr: 1 }} /> Delete
                                                </MenuItem>
                                            )}
                                        </Menu>
                                        <Dialog
                                            open={showPanUpdateDialog}
                                            onClose={() => setShowPanUpdateDialog(false)}
                                            PaperProps={{
                                                sx: {
                                                    boxShadow: 'none', // 👈 Removes the black glow
                                                    borderRadius: 2,    // Optional: smooth corners
                                                },
                                            }}
                                        >
                                            <DialogContent>
                                                <Typography variant="body5" sx={{ mt: 1 }}>
                                                    To generate the ID card, please ensure the <strong>PAN card number</strong> is updated and the payment status is marked as <em>Paid</em>.<br />
                                                    Click <strong>Update</strong> to modify the user details.
                                                </Typography>
                                            </DialogContent>
                                            <DialogActions sx={{ justifyContent: 'center' }}>
                                                <Button
                                                    onClick={() => {
                                                        setShowPanUpdateDialog(false);
                                                        handleEdit(menuUser); // your existing edit dialog trigger
                                                    }}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: "#2A289C",
                                                        color: "#fff",
                                                        borderRadius: '999px',
                                                        "&:hover": {
                                                            backgroundColor: "#1a1970",
                                                        },
                                                        px: 4,
                                                        py: 1,
                                                    }}
                                                >
                                                    Update
                                                </Button>
                                            </DialogActions>
                                        </Dialog>

                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow><TableCell colSpan={8} align="center">No records found.</TableCell></TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination Container */}
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    gap: 2
                }}
            >
                {/* Left Side - Total Pages */}
                <Typography
                    variant="body2"
                    sx={{
                        textAlign: 'left',
                        width: { xs: '100%', sm: 'auto' },
                        mb: { xs: 1, sm: 0 }
                    }}
                >
                    Total Pages: {Math.ceil(filteredData.length / rowsPerPage)}
                </Typography>

                {/* Right Side - Pagination Controls */}
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50, 75]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                        m: 0,
                        p: 0,
                        '.MuiTablePagination-toolbar': {
                            padding: 0,
                            minHeight: 'auto',
                            display: 'flex',
                            flexWrap: 'nowrap',
                            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                            alignItems: 'center',
                            width: '100%'
                        },
                        '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                            marginRight: 0,
                        },
                        '.MuiTablePagination-actions': {
                            marginLeft: 0,
                        },
                    }}
                />
            </Box>

            {/* Dialogs with refetch instead of page reload */}
            <EditUserDialog
                isOpen={openEditModal}
                onClose={() => setOpenEditModal(false)}
                user={selectedUser}
                onSuccess={refetch} // Use your existing refetch function
            />

            <DeleteConfirmationDialog
                open={openDialog && dialogMode === "delete"}
                onClose={() => setOpenDialog(false)}
                user={selectedUserForDelete}
                onSuccess={refetch} // Use your existing refetch function
            />

            <PaymentConfirmationDialog
                open={openDialog && dialogMode === "pay"}
                onClose={() => setOpenDialog(false)}
                user={selectedUserForPayment}
                onSuccess={refetch} // Use your existing refetch function
            />

            {/* Snackbar */}
            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }} />
        </div>
    );
};

export default DataTable;
